<template>
    <div
        v-if="actions && actions.length > 0"
        class="btn-group d-flex gap-1"
        role="group"
    >
        <template
            v-for="actionOrActionGroup in actions"
            :key="actionOrActionGroup.uniqueLoopKey"
        >
            <DropdownCompItemRenderer
                :dropdown-item="actionOrActionGroup"
                dropdown-menu-trigger-button-type="Secondary"
                :action-param="actionParam"
                :is-submenu="false"
            />
        </template>
    </div>
</template>
<script
    lang="ts"
    setup
    generic="TParam = any, TAction extends (...args: any[]) => any | Promise<any> = (param: TParam) => any | Promise<any>"
>
import { type DropdownItemTypes } from '@/objects';
import DropdownCompItemRenderer from '../Basic/BootstrapWrappers/DropdownComp/DropdownCompItemRenderer.vue';

defineProps<{
    actions?: DropdownItemTypes<TAction>[];
    actionParam?: TParam;
}>();
</script>
